import CarotekColors from "@carotek/utils/Colors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { GridOffset } from "@insite/mobius/GridContainer";
import Search from "@insite/mobius/Icons/Search";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(filtersAccordionStyles, {
    ...filtersAccordionStyles,
    accordion: {
        css: css`
            padding-top: 0px;
            border-bottom: 1px solid ${CarotekColors.grey10};
            dt[class^="AccordionSectionHeader"] {
                button {
                    border: 1px solid ${CarotekColors.grey10} !important;
                    border-top: 0 !important;
                    border-bottom: 0 !important;
                    background-color: ${CarotekColors.grey2};
                    font-size: 14px;
                    border-color: ${CarotekColors.grey2};
                    padding-left: 15px !important;

                    [class^="TypographyStyle"] {
                        font-size: 14px;
                        font-family: "OpenSansSemiBold";
                        color: ${CarotekColors.white};
                    }
                    svg {
                        width: 16px;
                        height: 16px;
                        stroke: ${CarotekColors.white};
                    }

                    &[aria-expanded="true"] {
                        border: 1px solid ${CarotekColors.grey10} !important;
                        background: ${CarotekColors.white};
                        border-color: ${CarotekColors.grey11};

                        [class^="TypographyStyle"] {
                            color: ${getColor("text.main")};
                        }
                        span[class^="toggle"] {
                            transform: rotate(180deg) translateX(6px);
                        }
                        svg {
                            stroke: ${getColor("text.main")};
                        }
                    }
                }
            }
            [class^="AccordionSectionPanel"] {
                border-bottom: 0;
                padding: 0 15px;

                [class^="CheckboxGroupStyle"] {
                    flex-direction: row;
                    margin: 7px 0;
                }

                [class^="CheckboxStyle"] {
                    [aria-checked="true"] {
                        + label {
                            font-family: "OpenSansSemiBold";
                        }
                    }

                    :hover {
                        cursor: pointer;
                        label[class^="TypographyStyle"] {
                            text-decoration: underline;
                        }
                    }
                }

                label[class^="TypographyStyle"] {
                    font-size: 14px;
                    color: ${CarotekColors.blue1};
                }
            }
        `,
    },
});
